export const CHANNELDATA = "CHANNELDATA";
